import { render } from "./Serology.vue?vue&type=template&id=7e53fd08"
import script from "./Serology.vue?vue&type=script&lang=js"
export * from "./Serology.vue?vue&type=script&lang=js"

import "./Serology.vue?vue&type=style&index=0&id=7e53fd08&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__